import { render } from "./SchedulingBoardView.vue?vue&type=template&id=e94b6ea6&ts=true"
import script from "./SchedulingBoardView.vue?vue&type=script&lang=ts"
export * from "./SchedulingBoardView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__